/* eslint-disable camelcase */
import { connect } from 'react-redux'
import _ from 'lodash'
import withDataLoader from '../../../Reports/Charts/withDataLoader'
import charts from '../../../Reports/Charts/charts'
import { withRouter } from '../../../../withRouter'
import { sizes } from '@lmc/common/constants'
import { CrashIcon, EmptyState } from '@lmc/ui-kit'
import CONSTANTS from 'utils/constants'

export const ResidentChartScreen = ({
  residents,
  router: {
    params: { id, reporting_id },
  },
}) => {
  if (!residents || !id || !reporting_id) return null

  const resident = _.find(residents, { id })
  const chartMap = {
    dashboard: charts.ChartsDashboard,
    activity_social: charts.ActivityChart,
    behaviour: charts.BehaviourChart,
    blood_glucose: charts.BloodGlucoseChart,
    blood_oxygen: charts.BloodOxygenChart,
    blood_pressure: charts.BloodPressureChart,
    daily: charts.DailyChart,
    fluids: charts.FluidsChart,
    health_visit: charts.HealthVisitChart,
    heart_rate: charts.HeartRateChart,
    incident: charts.IncidentsChart,
    meal: charts.FoodChart,
    mobility: charts.MobilityChart,
    mood: charts.MoodChart,
    must: charts.MustScoreChart,
    respiratory_rate: charts.RespiratoryRateChart,
    stool: charts.StoolChart,
    temperature: charts.TemperatureChart,
    turns: charts.TurnsChart,
    wash: charts.WashChart,
    waterlow: charts.WaterlowChart,
    weight: charts.WeightChart,
    painchek: charts.PainChekChart,
    bowel_movement: charts.StoolChart,
    seizure: charts.SeizureChart,
  }

  const Chart = chartMap[reporting_id]
  if (Chart) {
    const ChartWithLoader = withDataLoader(Chart, {
      url: () =>
        `/api/charts/resident/${resident.id}/${reporting_id}/logs`,
      errorMessage: 'No logs to show',
      title: Chart,
      enableMockData: !_.includes(
        [
          'dashboard',
          'mobility',
          'health_visit',
          'incident',
          'activity_social',
          'wash',
          'respiratory_rate',
          'behaviour',
          'painchek',
          'seizure',
        ],
        reporting_id
      ),
    })

    const chartProps = {
      resident,
      params: {
        resident_id: resident.id,
        chart_type: reporting_id,
      },
    }

    return (
      <div style={styles.container} data-cy="charts-container">
        <div data-cy="graph-chart" style={{ flex: 1, maxWidth: sizes.childScreen }}>
          <ChartWithLoader {...chartProps}/>
        </div>
      </div>
    )
  }

  return <EmptyState icon={CrashIcon} title={NO_CHART_MESSAGE} data-cy="empty-state-chart" />
}

const NO_CHART_MESSAGE = 'Ooops. Looks like something went wrong'

const styles = {
  container: {
    maxWidth: '1080px',
    paddingBottom: '50px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

const mapStateToProps = (state) => ({
  residents: state.data.residents,
})

export default connect(mapStateToProps)(withRouter(ResidentChartScreen))
